import { render, staticRenderFns } from "./TransferListDownload.vue?vue&type=template&id=c8b0297c&scoped=true&"
import script from "./TransferListDownload.vue?vue&type=script&lang=js&"
export * from "./TransferListDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b0297c",
  null
  
)

export default component.exports